import { Stack } from "@mui/material";
import { PatientProfile, Task } from "src/api/types";
import DosespotButton from "src/components/DosespotButton";
import { useClinician } from "src/context/SessionProvider/ClinicianProvider";
import { usePrescriptionPrescribedSubscription } from "src/realtime-subscriptions/usePrescriptionPrescribedSubscription";
import TaskWrapper from "src/wrappers/TaskWrapper";

interface Props {
  task: Task;
  onSuccess: () => Promise<void>;
  patient: PatientProfile;
}

const EPrescriptionRequestTask = ({ onSuccess, patient, task }: Props) => {
  const providerId = useClinician((c) => c.provider?.id);

  usePrescriptionPrescribedSubscription(
    providerId ?? null,
    task.task_type,
    onSuccess,
  );

  return (
    <TaskWrapper task={task}>
      <Stack gap={2}>
        <DosespotButton patientId={patient.id} />
      </Stack>
    </TaskWrapper>
  );
};

export default EPrescriptionRequestTask;
